<!-- Main Page Start -->

<div class="content-wrapper table-full-bx groups-permissions">
    <div class="page-content recruiterpanel">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox">
                    <div class="ibox-body">

                        <div class="page-heading slash_breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a routerLink="/groups"> Groups and Permissions </a></li>
                                <li class="breadcrumb-item"> Manage Users </li>
                            </ol>
                        </div>

                        <div class="flexbox">

                            <div class="iboxcontent">
                                <h3 class="pb-1"> Manage Users for Group : Recruiter </h3>
                            </div>

                            <div class="input-group-icon input-group-icon-left">
                                <div class="col-list-right">
                                    <form (ngSubmit)="searchFun()">
                                        <div class="form-group">
                                            <span class="input-icon input-icon-right font-16" (click)="searchFun()"><img src="assets/images/search.svg"></span>
                                            <input type="text" [(ngModel)]="search" autocomplete="off" class="form-control form-control-rounded form-control-solid search" name="search" id="key-search" placeholder="Search Id,Name,Email" />
                                            <span *ngIf="search" class="closeSearch" (click)="clearSearch()">&times;</span>
                                        </div>
                                    </form>
                                </div>

                                <!-- <div class="col-list-right">
                                    <a [routerLink]="'add-users-group/' + userID" class="commonBtn2"><img src="assets/images/ic_add_project.svg" class="ap" /> Add Users </a>
                                </div> -->
                            </div>
                        </div>
                        <!-- end -->
                        <!-- Table -->
                        <div class="table-scroll table-wrapper smalltab table-responsive">
                            <table id="example" class="table table-bordered table-hover m-0  " style="width: 100%;">
                                <thead>
                                    <tr>
                                        <th>ID </th>
                                        <th>Full name </th>
                                        <th>Email ID </th>
                                        <th>Action </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- 1 -->
                                    <tr *ngFor="let data of usersData">
                                        <td><a href="javascript:void(0);">{{data?.id}} </a></td>
                                        <td class="td-linked">
                                            <a (click)="goToUserDetail(data?.id)" class="jobid linkedIn">
                                                <span class="text-orange">{{data?.fullName}} </span>
                                                <i class="icons"><img (click)="goToLinkedInUrl(data?.linkedin)" *ngIf="data?.linkedin" src="assets/images/ic_linkedin-logo.svg"></i>
                                            </a>
                                        </td>
                                        <td><a href="javascript:void(0);" > {{data?.email}} </a></td>
                                        <td><a href="javascript:void(0);" class="remove-user" (click)="removeUser(data?.assign_user_groups[0]?.id)"> Remove User </a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="noDataFound" *ngIf="usersData.length == 0">
                            <h2>No Records Found</h2>
                        </div>

                        <!--  pagination  -->
                        <div class="col-sm-12 p-0" *ngIf="usersData.length > 9">
                            <ul class="pagination ">
                                <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                            </ul>
                        </div>
                        <!-- end -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End -->